import { MonitoringCockpitService, DashboardService, ConsultaApiService, JobEnviaDadosWsRest, JobEnviaDadosWsSoap, RestToSoapService, WorkflowService, CadastroDbService, CredentialsService, FromToService, ParameterService, SequenceService, SocketServerService, EmailServerService, ClientService, UserService } from '../../../services/module'

export default {
  dashboard: DashboardService,
  monitoring: MonitoringCockpitService,
  apiQuery: ConsultaApiService,
  jobRest: JobEnviaDadosWsRest,
  jobSoap: JobEnviaDadosWsSoap,
  restToSoap: RestToSoapService,
  workflow: WorkflowService,
  dbRegister: CadastroDbService,
  credentials: CredentialsService,
  fromTo: FromToService,
  parameters: ParameterService,
  sequences: SequenceService,
  socketServer: SocketServerService,
  emailServer: EmailServerService,
  clients: ClientService,
  users: UserService
}
